import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import { SolPriceProvider } from './contexts/SolPriceContext';
import { ActivityProvider } from './contexts/ActivityContext';
import { VerificationProvider } from './contexts/VerificationContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Home from './pages/Home';
import Explore from './pages/Explore';
import Capsules from './pages/Capsules';
import CreatePiece from './pages/CreateNFT';
import CreateCollection from './pages/CreateCollection';
import Activity from './pages/Activity';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import VerificationPage from './pages/VerificationPage';
import Help from './pages/Help';
import ProfileManagement from './pages/ProfileManagement';

// Profile pages

import Listings from './pages/Listings';
import Offers from './pages/Offers';
import Portfolio from './pages/Portfolio';
import Created from './pages/Created';
import Favorites from './pages/Favorites';
import OutfitBuilder from './pages/OutfitBuilder';
import Outfits from './pages/Outfits';
import OutfitPage from './pages/OutfitPage';
import CapsulePage from './pages/CapsulePage';
import CreatorProfile from './pages/CreatorProfile';
import TradePieces from './pages/TradePieces';
import DevChain from './pages/DevChain';

function App() {
  console.log('App component is rendering');
  
  return (
    <WalletProvider>
      <SolPriceProvider>
        <ActivityProvider>
          <VerificationProvider>
            <NotificationsProvider>
                <Routes>
              {/* User Routes */}
              <Route path="/*" element={
                <div className="flex h-screen w-full overflow-hidden" style={{ backgroundColor: '#000000' }}>
                  <Sidebar />
                  <div className="flex-1 flex flex-col overflow-hidden min-w-0">
                    <Header />
                    <main className="flex-1 overflow-y-auto md:overflow-x-hidden scrollbar-custom pb-0">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/explore" element={<Explore />} />
                        <Route path="/capsules" element={<Capsules />} />
                        <Route path="/create-nft" element={<CreatePiece />} />
                        <Route path="/create-collection" element={<CreateCollection />} />
                        <Route path="/activity" element={<Activity />} />
                
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/profile/:username" element={<Profile />} />
                        <Route path="/profile-management" element={<ProfileManagement />} />
                        
                        {/* Profile Routes */}
                        <Route path="/portfolio" element={<Portfolio />} />
                        <Route path="/created" element={<Created />} />
                        <Route path="/listings" element={<Listings />} />
                        <Route path="/favorites" element={<Favorites />} />
                        <Route path="/offers" element={<Offers />} />
                        <Route path="/outfits" element={<Outfits />} />
                        
                        {/* Legacy Profile Routes */}
                        <Route path="/profile/listings" element={<Listings />} />
                        <Route path="/profile/offers" element={<Offers />} />
                        <Route path="/profile/portfolio" element={<Portfolio />} />
                        <Route path="/profile/created" element={<Created />} />
                        <Route path="/profile/favorites" element={<Favorites />} />
                        <Route path="/profile/activity" element={<Activity />} />
                        <Route path="/outfit-builder" element={<OutfitBuilder />} />
                        <Route path="/outfits" element={<Outfits />} />
                        <Route path="/outfit/:outfitId" element={<OutfitPage />} />
                        <Route path="/trade-pieces" element={<TradePieces />} />
                        
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/verification" element={<VerificationPage />} />
                        <Route path="/help" element={<Help />} />
                        
                        {/* Capsule and Creator Pages */}
                        <Route path="/capsule/:capsuleId" element={<CapsulePage />} />
                        <Route path="/creator/:creatorId" element={<CreatorProfile />} />
                        
                        {/* Dev Tools */}
                        <Route path="/dev/chain" element={<DevChain />} />
                      </Routes>
                    </main>
                  </div>
                </div>
              } />
            </Routes>
            </NotificationsProvider>
          </VerificationProvider>
        </ActivityProvider>
      </SolPriceProvider>
    </WalletProvider>
  );
}

export default App; 